import z from "zod";

const workspaceSettingChangeSchema = z.object({
    old: z.number().nullable(),
    new: z.number(),
});

const workspaceConfigurationChangedDataSchema = z
    .object({
        ip: z.string().nullish(),
        guid: z.string().nullish(),
        name: z.string().nullish(),
    })
    .catchall(z.unknown());

type WorkspaceSettingChange = z.infer<typeof workspaceSettingChangeSchema>;

export { workspaceConfigurationChangedDataSchema, workspaceSettingChangeSchema };
export type { WorkspaceSettingChange };
